//src/types/Helper/FirebaseProperties.ts

import { Timestamp } from 'firebase/firestore'

export class FirebaseProperties {
  firebaseInfo: FirebaseInterface = createFirebaseInterface()
  thisCollection: string = ''
  thisDocument: string = ''
}

export interface FirebaseInterface {
  __id: string
  _createdAt: Timestamp
  _updatedAt: Timestamp
  _updatedBy: string
  _createdBy: string
}

export function createFirebaseInterface(init: Partial<FirebaseInterface> = {}): FirebaseInterface {
  return {
    __id: '-1',
    _createdAt: Timestamp.now(),
    _updatedAt: Timestamp.now(),
    _updatedBy: '-1',
    _createdBy: '-1',
    ...init
  }
}

export function convertTimestampsToDates(obj: any): any {
  if (obj === null || obj === undefined) return obj

  if (isFirebaseInterface(obj)) return obj

  if (obj instanceof Timestamp) {
    return obj.toDate()
  }

  if (typeof obj === 'object' && !Array.isArray(obj)) {
    const newObj: any = {}
    for (const key in obj) {
      newObj[key] = convertTimestampsToDates(obj[key])
    }
    return newObj
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => convertTimestampsToDates(item))
  }

  return obj
}

//Convert date or date convert
export function convertDatesToTimestamps(obj: any): any {
  if (obj === null || obj === undefined) return obj

  if (isFirebaseInterface(obj)) return obj

  if (obj instanceof Date) {
    return Timestamp.fromDate(obj) // Convert Date to Firestore Timestamp
  }

  if (typeof obj === 'object' && !Array.isArray(obj)) {
    const newObj: any = {}
    for (const key in obj) {
      newObj[key] = convertDatesToTimestamps(obj[key])
    }
    return newObj
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => convertDatesToTimestamps(item))
  }

  return obj
}

export function isFirebaseInterface(obj: unknown): obj is FirebaseInterface {
  return (
    !!obj &&
    typeof obj === 'object' &&
    '__id' in obj &&
    typeof (obj as FirebaseInterface).__id === 'string' &&
    '_createdAt' in obj &&
    '_updatedAt' in obj &&
    '_createdBy' in obj &&
    typeof (obj as FirebaseInterface)._createdBy === 'string' &&
    '_updatedBy' in obj &&
    typeof (obj as FirebaseInterface)._updatedBy === 'string'
  )
}
